import { GlassCard, GlassCardContent } from "@/components/ui/glass-card";
import { Button } from "@/components/ui/button";
import { Plus, Building2, Users, Zap } from "lucide-react";

interface EmptyStateProvidersProps {
  onAddProvider: () => void;
}

export function EmptyStateProviders({ onAddProvider }: EmptyStateProvidersProps) {
  return (
    <div className="text-center py-12">
      <div className="max-w-md mx-auto">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Building2 className="w-8 h-8 text-primary" />
          </div>
        </div>
        
        <h3 className="text-xl font-semibold mb-2">Connect Your Identity Providers</h3>
        <p className="text-muted-foreground mb-8">
          Sync users and groups from your directory services to automate device management and policy assignment.
        </p>
        
        <div className="grid gap-4 mb-8">
          <GlassCard variant="subtle" hover={false} className="text-left">
            <GlassCardContent className="flex items-center gap-3 p-4">
              <Users className="w-5 h-5 text-info" />
              <div>
                <div className="font-medium">Automatic User Sync</div>
                <div className="text-sm text-muted-foreground">Keep user profiles updated automatically</div>
              </div>
            </GlassCardContent>
          </GlassCard>
          
          <GlassCard variant="subtle" hover={false} className="text-left">
            <GlassCardContent className="flex items-center gap-3 p-4">
              <Zap className="w-5 h-5 text-success" />
              <div>
                <div className="font-medium">Dynamic Tag Assignment</div>
                <div className="text-sm text-muted-foreground">Use user attributes for smart device grouping</div>
              </div>
            </GlassCardContent>
          </GlassCard>
        </div>
        
        <Button onClick={onAddProvider} size="lg">
          <Plus className="w-4 h-4 mr-2" />
          Add Identity Provider
        </Button>
        
        <div className="mt-6 text-sm text-muted-foreground">
          Supports Google Workspace, Azure AD, LDAP, Okta, and SAML
        </div>
      </div>
    </div>
  );
}